<template>
<div class="home-page-wrapper">
  <el-row :gutter="20"><Banner/></el-row>
  <el-row :gutter="20"><Entry/></el-row>
  <el-row :gutter="20"><Leaflet/></el-row>
</div>
</template>

<script>
import Banner from './widget/banner'
import Entry from './widget/entry'
import Leaflet from './widget/leaflet'

export default {
  components: {
    Banner,
    Entry,
    Leaflet
  }

}
</script>

<style lang="stylus" scoped>


</style>